import _ from 'lodash'

// const processPortalChildWidgets = (widgetsList, widgets, path) => _.reduce(widgetsList, (ret, widgetData) => {
//     const widget = widgets.get(widgetData.ref, Map());
//     if (widget.size > 0) {
//         return [
//             ...ret,
//             ...processChildWidgets(
//                 widget.toJS(),
//                 widgets.toJS(),
//                 [...path, widgetData.uid, widgetData.ref]
//             )
//         ];
//     } else {
//         return ret;
//     }
// }, []);
export const isHaveSFMappingActionGet = (conf, sfMapping) => {
  let isHaveMapping = false
  if (conf.isBulk) {
    _.each(conf.list, function (sfItem) {
      if (sfItem) {
        if (sfMapping && sfMapping[sfItem.value]) {
          isHaveMapping = true
        }
      }
    })
  } else {
    if (sfMapping && sfMapping[conf.value]) {
      isHaveMapping = true
    }
  }
  return isHaveMapping
}
